module.exports = __webpack_public_path__ + "img/xiaolian.f8058a4e.png";